import React from 'react'

import ApexChart from 'react-apexcharts'
import { ChartProvider, useChartContext, UseChartProps } from './useChart'
import { Spin } from 'antd'
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

export const View: React.FC<{}> = (props) => {
  const {
    chartRef,
    loading,
    chartProps,
    vitalOptions
  } = useChartContext()

  return (
    <div className="ui-chart">
      <div className="ui-chart__header">
        <div className="ui-chart__header__title">
          {vitalOptions?.vital?.displayName}
        </div>
      </div>
      <div className="ui-chart__content">
        <Spin spinning={loading} indicator={<HealthemSpinner size={70}/>}>
          <ApexChart
            ref={chartRef}
            {...(chartProps || {})}
          />
        </Spin>
      </div>
    </div>
  )
}

export const Chart: React.FC<UseChartProps> = (props) => {
  return <ChartProvider {...props} >
    <View />
  </ChartProvider>
}
